import React from "react";
import logoImage from "../assets/we white.png";
import "./Footer.css";

const Footer = () => {
  const sections = [
    {
      title: "About THE WE DEV",
      links: [
        { name: "About Us", href: "/#about" },
        { name: "Contact Us", href: "/#contact" },
      ],
    },
    {
      title: "Services",
      links: [
        { name: "Web Development", href: "/services/web-development" },
        { name: "App Development", href: "/services/app-development" },
        { name: "SEO Optimization", href: "/services/search-engine-optimization" },
        { name: "Social Media Marketing (SMM)", href: "/services/social-media-management" },
      ],
    },
  ];

  return (
    <footer className="footer-dark">
      <div className="footer-grid footer-grid-3">
        {/* Logo (Left) */}
        <div className="footer-logo-section">
          <img
            src={logoImage}
            alt="THE WE DEV Logo"
            className="footer-logo-image"
          />
        </div>

        {/* About (Center) */}
        <div className="footer-section footer-section-center">
          <h3 className="footer-section-title">{sections[0].title}</h3>
          <ul className="footer-links">
            {sections[0].links.map((link, i) => (
              <li key={i}>
                <a href={link.href} className="footer-link">
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Services (Right) */}
        <div className="footer-section footer-section-right">
          <h3 className="footer-section-title">{sections[1].title}</h3>
          <ul className="footer-links">
            {sections[1].links.map((link, i) => (
              <li key={i}>
                <a href={link.href} className="footer-link">
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom-bar">
        <div className="footer-copyright">
          <p>© 2025 THE WE DEV. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
